import React, { useCallback } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../../api/api";
import ChangePasswordForm from "../../../Home/Forms/ChangePasswordForm";

const ChangePasswordModal = ({ show, onClose, user, onSubmit, onSuccess, t }) => {
    const handleSubmit = useCallback((postData) => {
        if (onSubmit) {
            onSubmit(postData);
            return;
        }
        const _toastId = toast(t("Processing"), { position: "bottom-left", autoClose: false });
        api.put(`/Users/${user.Id}?ChangePassword=true`, postData)
            .then((response) => {
                if (response.data.code === "success") {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"><i className="icon fal fa-shield-check"></i> {t("Pages.ProfileEdit.success_toast.Title")}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        autoClose: 5000,
                    });
                    if (onSuccess) onSuccess();
                    onClose();
                } else {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"><i className="icon fal fa-bug"></i> {t("Pages.ProfileEdit.error_AllInformationIsRequired_toast.Title")}</div></div>,
                        type: toast.TYPE.ERROR,
                        autoClose: 5000,
                    });
                }
            })
            .catch(() => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"><i className="icon fal fa-wifi-slash"></i> {t("Error.NoConnection.Title")}</div></div>,
                    type: toast.TYPE.ERROR,
                    autoClose: 5000,
                });
            });
    }, [user, onSubmit, onClose, onSuccess, t]);

    if (!show || !user) return null;

    return (
        <Modal size="md" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-key text-primary icon ml-2"></i>
                        {t("Pages.UsersControl.action.change_password")}:
                        <span className="text-primary mr-1">{user.Name}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category">
                    <div className="widget-body">
                        <ChangePasswordForm onSubmit={handleSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChangePasswordModal;
